var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatabaseBold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 10C38 10 38 2 20 2C2 2 2 10 2 10M38 10V18M38 10C38 10 38 18 20 18C2 18 2 10 2 10M2 10V18M2 26V34C2 34 2 42 20 42C38 42 38 34 38 34V26M2 26C2 26 2 34 20 34C38 34 38 26 38 26M2 26V18M38 26V18M2 18C2 18 2 26 20 26C38 26 38 18 38 18",
    stroke: "#071A24",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatabaseBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/database_bold.b1bcba8fd65569f327de34a605c09714.svg";